module.exports = __webpack_public_path__ + "img/Post-1.d4e394d.webp";